<template>
  <div class="cmb-about">
    <div class="intro-model">
      <div class="title">中医评测系统 CMBenchmark</div>
      <div class="desc">
        CMB是中国全方位、多层次的医疗标杆。它包含280，839个选择题和74个复杂病例咨询问题，涵盖了所有临床医学专业和各种专业水平。该平台旨在全面评估模特的医学知识和临床咨询能力。具体组成如下。你可以在
        <a
          class="ext-link"
          target="_blank"
          href="https://huggingface.co/datasets/FreedomIntelligence/CMB"
          >HuggingFace</a
        >上查看和下载我们的数据集。
      </div>
      <img class="cmb-img" src="@/assets/images/cmb/CMB.png" alt="" />

      <div class="explain">
        <h2>Components</h2>
        <div class="block-list">
          <li>
              CMB-Exam: Comprehensive multi-level assessment for medical
              knowledge
            <ul class="item">
              <li>
                Structure: 6 major categories and 28 subcategories, View Catalog
              </li>
              <li>
                CMB-test: 400 questions per subcategories, 11200 questions in
                total
              </li>
              <li>
                CMB-val: 280 questions with solutions and explanations; used as
                source for CoT and few-shot
              </li>
              <li>
                CMB-train: 269359 questions for medical knowledge injection
              </li>
            </ul>
          </li>
          <li>CMB-Clin: 74 cases of complex medical inquires</li>
        </div>
      </div>
    </div>
    <div class="intro-model">
      <div class="title">数据</div>
      <div class="desc">
        我们的数据可以直接从<a
          class="ext-link"
          target="_blank"
          href="https://huggingface.co/datasets/FreedomIntelligence/CMB"
          >HuggingFace</a
        >下载。请参考我们的GitHub，了解如何访问和利用这些数据。
      </div>
    </div>
    <div class="intro-model">
      <div class="title">引用</div>
      <pre class="bibtax">
@article{wang2023cmb,
            title={CMB: A Comprehensive Medical Benchmark in Chinese},
            author={Wang, Xidong and Chen, Guiming Hardy and Song, Dingjie and Zhang, Zhiyi and Chen, Zhihong and Xiao, Qingying and Jiang, Feng and Li, Jianquan and Wan, Xiang and Wang, Benyou and others},
            journal={arXiv preprint arXiv:2308.08833},
            year={2023}
}</pre
      >

      <pre class="bibtax">
@misc{cmedbenchmark,
            title={CMB: Chinese Medical Benchmark},
            author={Xidong Wang*, Guiming Hardy Chen*, Dingjie Song*, Zhiyi Zhang*, Qingying Xiao, Xiangbo Wu, Feng Jiang, Jianquan Li, Benyou Wang},
            note={Xidong Wang, Guiming Hardy Chen, Dingjie Song, and Zhiyi Zhang contributed equally to this github repo.},
            year = {2023},
            publisher = {GitHub},
            journal = {GitHub repository},
            howpublished = {\url{https://github.com/FreedomIntelligence/CMB}},
}</pre
      >
    </div>
    <div class="intro-model">
      <div class="title">联系我们</div>
      <div class="desc">
        有关CMB的问题，请联系我们xxxxxxxxxxxxxxxx@163.com办事处或在Github上创建一个问题。如果你对潜在的合作感兴趣，请联系xxxxxxxxxxxx@cuhk.edu.cn。
        下载。请参考我们的GitHub，了解如何访问和利用这些数据。
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cmb-about {
  margin-top: 40px;
  .intro-model {
    text-align: left;
    margin-bottom: 60px;
    .title {
      height: 44px;
      font-weight: 500;
      font-size: 36px;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 24px;
    }
    .desc {
      font-weight: 400;
      font-size: 16px;
      color: #4e5969;
      line-height: 24px;

      .ext-link {
        color: #165dff;
        text-decoration-line: underline;
      }
    }

    .bibtax {
      padding: 16px;
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 16px;
      word-wrap: break-word;
      white-space: pre-wrap;
      margin-bottom: 24px;
    }
    .cmb-img {
      height: 723px;
    }
    .explain {
      font-weight: 400;
      font-size: 16px;
      color: #4e5969;
      .block-list {
        margin-top: 12px;
        font-weight: 400;
        font-size: 16px;
        color: #4e5969;
        .item {
          margin-left: 24px;
          list-style-type: circle;
        }
      }
    }
  }
}
</style>